'use client';

import { Clock } from 'lucide-react';

import { formatElapsed, toIsoDuration } from '@/components/assistant-ui/thread/format-elapsed';
import { useTickNow } from '@/components/assistant-ui/thread/use-tick-now';

/** Static `<time>` showing a frozen elapsed-ms value. */
export function StepElapsed({ elapsedMs }: { elapsedMs: number }) {
  return (
    <time
      dateTime={toIsoDuration(elapsedMs)}
      className="text-xs text-muted-foreground tabular-nums"
    >
      {formatElapsed(elapsedMs)}
    </time>
  );
}

/** `<time>` that ticks against `useTickNow` while the trail is running. */
export function LiveStepElapsed({ anchor }: { anchor: number }) {
  const tickNow = useTickNow();
  return <StepElapsed elapsedMs={Math.max(0, tickNow - anchor)} />;
}

/** Total-elapsed badge with a clock glyph; clock pulses while live. */
export function ElapsedTimer({ elapsedMs, isLive }: { elapsedMs: number; isLive: boolean }) {
  return (
    <span className="flex items-center gap-1 text-xs text-muted-foreground tabular-nums">
      <Clock
        aria-hidden="true"
        className={`h-3.5 w-3.5 ${isLive ? 'animate-pulse motion-reduce:animate-none' : ''}`}
      />
      <time dateTime={toIsoDuration(elapsedMs)}>{formatElapsed(elapsedMs)}</time>
    </span>
  );
}
